class ArchiveProduct {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    this.initManyBlock();
    this.initManyToggle();
  }

  /**
   * ul の li が 7 以上なら main-area-block に js-many-block を付与
   */
  initManyBlock() {
    const MIN_LI_COUNT = 7;
    $('.main-area-block').each((_, block) => {
      const $block = $(block);
      const $ul = $block.find('ul').first();
      const liCount = $ul.find('> li').length;

      if (liCount >= MIN_LI_COUNT) {
        $block.addClass('many-block js-many-block');
        $ul.addClass('js-many-list');
      }
    });
  }

  /**
   * many-block の「もっと見る」開閉（s-intro__more 風）
   */
  initManyToggle() {
    const $blocks = $('.js-many-block');
    if (!$blocks.length) return;

    $blocks.each((_, block) => {
      const $block = $(block);
      const $list = $block.find('.js-many-list');
      const $toggle = $block.find('.js-many-toggle');
      const $text = $block.find('.js-many-toggle-text');
      const $icon = $block.find('.js-many-toggle-icon');

      if (!$list.length || !$toggle.length) return;

      const COLLAPSED_HEIGHT = '63rem';

      const handleToggle = () => {
        const isExpanded = $block.hasClass('is-expanded');

        if (isExpanded) {
          $block.removeClass('is-expanded');
          $list.css('max-height', COLLAPSED_HEIGHT);
          $toggle.attr('aria-expanded', 'false').attr('aria-label', '商品一覧を展開');
          $text.text('もっと見る');
          $icon.removeClass('is-open');
        } else {
          const fullHeight = $list[0].scrollHeight;
          $list.css('max-height', fullHeight + 'px');
          $block.addClass('is-expanded');
          $toggle.attr('aria-expanded', 'true').attr('aria-label', '商品一覧を閉じる');
          $text.text('閉じる');
          $icon.addClass('is-open');
        }
      };

      $toggle.on('click', handleToggle);
      $toggle.on('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      });
    });
  }
}